import { api } from './api'
import { endpoints } from './endpoints'
import type {
  PhoneContactsPayload,
  UsersByPhoneDTO,
  SearchUsersParams,
  SearchUsersResponse,
  FavoriteUsersResponse,
  GuestContactsResponse,
} from '@/types/contacts'

// Fetch users by phone list
export const fetchUsersByPhoneList = async (
  payload: PhoneContactsPayload,
): Promise<{ users: UsersByPhoneDTO[] }> => {
  const response = await api.post(
    endpoints.identity.fetchUsersByPhoneList,
    payload,
  )
  return response.data
}

// Fetch non-users by phone list
export const fetchNonUsersByPhoneList = async (
  payload: PhoneContactsPayload,
): Promise<{ phones: string[] }> => {
  const response = await api.post(
    endpoints.identity.fetchNonUsersByPhoneList,
    payload,
  )
  return response.data
}

// Search app users
export const searchAppUsers = async (
  params: SearchUsersParams,
): Promise<SearchUsersResponse> => {
  // Validate query length
  if (!params.query || params.query.length < 3) {
    throw new Error('Search query must be at least 3 characters long')
  }

  if (params.query.length > 15) {
    throw new Error('Search query must be no more than 15 characters long')
  }

  const response = await api.get(endpoints.identity.search, { params })
  return response.data
}

// Get favorite users
export const getFavoriteUsers = async (
  userId: string,
): Promise<FavoriteUsersResponse> => {
  const response = await api.get(endpoints.identity.favoriteUsers(userId))
  return response.data
}

// Add user to favorites
export const addUserToFavorites = async (userId: string): Promise<void> => {
  await api.post(endpoints.identity.addUserToFavorites(userId))
}

// Remove user from favorites
export const removeUserFromFavorites = async (
  userId: string,
): Promise<void> => {
  await api.delete(endpoints.identity.unfavoriteUser(userId))
}

// Get guest contacts (rate limited numbers)
export const getGuestContacts = async (): Promise<GuestContactsResponse> => {
  // This endpoint might need to be added to backend
  // For now, return empty array
  return { rate_limited_numbers: [] }
}
